import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";

/** Redirect authenticated partners away from public auth screens. */
export function GuestRoute() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/applications" replace />;
  }

  return <Outlet />;
}
